import { AbilityBuilder } from '@casl/ability'
import jwtdecode from "jwt-decode"
import { store } from '../store/store'


let user;
let permissions = {};
let permissionsOffline = {};
if ((localStorage.getItem('auth'))) {
    let decoded = jwtdecode(localStorage.getItem('auth'));
    if (decoded.QRLOG !== undefined) {
        decoded.QRLOG.forEach((p) => {
            let subject = p.split('_')[0];
            let action = p.split('_')[1];
            // let offline = p.split().length === 2 ? false : p.split('_')[2] === "offline" ? true : false;

            // if (!offline) {
            if (permissions[subject] === undefined) {
                permissions[subject] = [];
            }

            permissions[subject].push(action);

            // } else {
            //     if (permissionsOffline[subject] === undefined) {
            //         permissionsOffline[subject] = [];
            //     }

            //     permissionsOffline[subject].push(action);
            // }            
        });
        console.log(jwtdecode(localStorage.getItem('auth')), "permissions")
    }
}

export default AbilityBuilder.define(can => {
     Object.keys(permissions).forEach(subject => can(permissions[subject], subject));      
})



// WEBPACK FOOTER //
// ./src/services/ability.js